import {Injectable} from '@angular/core';
import {CoreApiService} from 'src/app/core/core-api.service';
import {endpoints} from 'src/environments/endpoints';

@Injectable({
  providedIn: 'root'
})
export class InstituicoesRegimeService {

  constructor(private apiService: CoreApiService) {
  }

  instituiçõesRegime() {
    return this.apiService.get(`${endpoints.listarInstituicoesRegime}`)
  }
}
